/**
 * Products Service Hooks
 * React hooks for accessing product management services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all products-related services
 */
export function useProductsServices() {
    const { services } = useCCMS();
    if (!services?.products) {
        throw new Error('Products services not available. Ensure CCMSProvider is configured with products services.');
    }
    return services.products;
}
export function useProductService() {
    return useProductsServices().product;
}
export function useProductTypeService() {
    return useProductsServices().productType;
}
export function useProductColorService() {
    return useProductsServices().productColor;
}
export function useProductSizeService() {
    return useProductsServices().productSize;
}
export function useProductImageService() {
    return useProductsServices().productImage;
}
export function useProductStockService() {
    return useProductsServices().productStock;
}
export function useProductTransactionService() {
    return useProductsServices().productTransaction;
}
export function useTransactionTypeService() {
    return useProductsServices().transactionType;
}
/**
 * Hook to access StoreCatalogueService — the Store admin read surface
 * (paged product and stock grids, catalogue aggregates).
 */
export function useStoreCatalogueService() {
    return useProductsServices().storeCatalogue;
}
//# sourceMappingURL=useProductsServices.js.map